import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ConfirmationDialog {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmType?: 'danger' | 'warning' | 'primary';
  onConfirm: () => void;
  onCancel?: () => void;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationService {
  public dialogSubject = new BehaviorSubject<ConfirmationDialog | null>(null);
  public dialog$: Observable<ConfirmationDialog | null> = this.dialogSubject.asObservable();

  confirm(options: ConfirmationDialog) {
    this.dialogSubject.next({
      confirmText: 'Confirm',
      cancelText: 'Cancel',
      confirmType: 'primary',
      ...options
    });
  }

  close() {
    this.dialogSubject.next(null);
  }
}
